import React, { Fragment, ComponentProps } from 'react'
import { Clear } from '@css/common.elements'
import {
  ArticleSectionContainer,
  ContentWrapper,
  MainContent,
  Sidebar,
  SidebarContent,
  SectionTitle,
  SectionText,
  SectionLink,
  RelatedLink,
  Sep, ArticleSectionRow, SocialShareButtonsWrapper, ShareText
} from './ArticleSection.elements'
import {RelatedArticleCard, ArticleRelated} from "@pages/Homepage/components/RelatedArticleCard";
import {ArticleLeadgenCard} from "@pages/Homepage/components/ArticleLeadgenCard";
import {ArticleCallNow, ArticleCallNowCard} from "@pages/Homepage/components/ArticleCallNowCard";
import {SocialShareButtons, ShareButtonProps} from "@components/SocialShareButtons";
import {LeadgenPopupType} from "@components/LeadgenPopupFlow";

type ArticleTextSection = {
  title: string
  text: string
}

export type ArticleRelatedLink = {
  text: string
  link: string
  selected?: boolean
}

export type ArticleSectionProps = {
  type: string
  articleMetaText: string
  articleRelatedLinks: ArticleRelatedLink[]
  articleContent: ArticleTextSection[]
  articleRelated: ArticleRelated
  articleLeadgen: ComponentProps<typeof ArticleLeadgenCard>
  articleCallNow: ArticleCallNow
  onSubmit: (value?: any) => void
  phoneMapping: PhoneMapping
  shareOptions: ShareButtonProps[]
  leadgenPopupType?: LeadgenPopupType;
}

export const ArticleSection: React.FunctionComponent<ArticleSectionProps> = (props) => (
  <ArticleSectionContainer>
    <ContentWrapper>
      <MainContent>
        <ArticleSectionRow>
          <SectionText>
            {props.articleMetaText}
          </SectionText>
          { props.shareOptions &&
            <SocialShareButtonsWrapper>
              <ShareText dangerouslySetInnerHTML={{__html: 'SHARE:'}}/>
              <SocialShareButtons shareOptions={props.shareOptions} />
            </SocialShareButtonsWrapper>
          }
        </ArticleSectionRow>
        <Sep />
        { props.articleContent.map((data, index) => (
            <Fragment key={`article-section-${index}`} >
              {data.title && (
                <SectionTitle dangerouslySetInnerHTML={{__html: data.title}} />
              )}
              <SectionText dangerouslySetInnerHTML={{__html: data.text}}/>
            </Fragment>
          ))
        }
        <Sep />
          <SectionTitle>Related Articles</SectionTitle>
          { props.articleRelatedLinks.map((data, index) => (
              <RelatedLink key={`related-link-${index}`}>
                <SectionText>
                  <SectionLink href={data.link}>{data.text}</SectionLink>
                </SectionText>
              </RelatedLink>
          ))
        }
        <Sep />
        <ArticleSectionRow>
          <SectionText>
            {props.articleMetaText}
          </SectionText>
          { props.shareOptions &&
            <SocialShareButtonsWrapper>
              <ShareText dangerouslySetInnerHTML={{__html: 'SHARE:'}}/>
              <SocialShareButtons shareOptions={props.shareOptions} />
            </SocialShareButtonsWrapper>
          }
        </ArticleSectionRow>
      </MainContent>
      <Sidebar>
        <SidebarContent>
          <RelatedArticleCard
            title={props.articleRelated.title}
            subtitle={props.articleRelated.subtitle}
            links={props.articleRelated.links} />
          <Clear />
          <ArticleLeadgenCard
            title={props.articleLeadgen.title}
            subtitle={props.articleLeadgen.subtitle}
            buttonHelpText={props.articleLeadgen.buttonHelpText}
            buttonText={props.articleLeadgen.buttonText}
            inputs={props.articleLeadgen.inputs}
            onSubmit={props.onSubmit}
            leadgenPopupType={props.leadgenPopupType}
          />
          <ArticleCallNowCard
            title={props.articleCallNow.title}
            hours={props.articleCallNow.hours}
            phoneMapping={props.phoneMapping}
          />
        </SidebarContent>
      </Sidebar>
      <Clear />
    </ContentWrapper>
  </ArticleSectionContainer>
)
